import Pattern from "@assets/PNG/Patterns/Pattern2.png";
import ChevronRight from "@assets/SVG/ChevronRight.svg";
import ERAMANLogo from "@assets/SVG/Logos/ERAMAN.svg";
import MAHBLogo from "@assets/SVG/Logos/MAHB.svg";
import Logo from "@assets/SVG/Logos/MAHBBig.svg";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { magpApiURL } from "~/Utils";
import { getModulePath } from "~/Utils/StringConstants";

const dedicatedModules = [
  {
    name: "MAGP",
    label: "MAGP",
    backgroundColor: "lightYellow",
    logo: MAHBLogo,
    content:
      "Upgrading and enhancing the website's design, functionality, and tech stack for a contemporary user experience.",
  },
  {
    name: "ERAMAN",
    label: "Eraman",
    backgroundColor: "secondary-100",
    logo: ERAMANLogo,
    content: "Website Development, aiming to create a dynamic and user-centric platform.",
  },
  // {
  //   name: "APSS",
  //   label: "APSS",
  //   backgroundColor: "lightBlue",
  //   logo: APSSLogo,
  //   content:
  //     "Airport Protection Security Service Application: A comprehensive mobile solution ensuring efficient and stringent security measures for airport personnel and travellers",
  // },
  // { name: "EMPLOYEEAPP", label: "Employee App", backgroundColor: "lightYellow", logo: MAHBLogo },
  // { name: "MAHBCommercial", label: "MAHB Commercial", backgroundColor: "lightYellow", logo: MAHBLogo },
  {
    name: "PASSENGER BUTTERFLY EFFECT",
    label: "Passenger Butterfly Effect",
    backgroundColor: "lightYellow",
    logo: MAHBLogo,
    content:
      "Implementing a modern, visually appealing, and user-friendly design to enhance the website's aesthetics and functionality.",
  },
   {
    name: "PASSENGER ECMS",
    label: "Passenger ECMS",
    backgroundColor: "lightYellow",
    logo: MAHBLogo,
    content:
      "Implementing a modern, visually appealing, and user-friendly design to enhance the website's aesthetics and functionality.",
  },
  {
    name: "CORPORATE",
    label: "MAHB Corporate",
    backgroundColor: "lightYellow",
    logo: MAHBLogo,
    content:
      "Implementing a modern, visually appealing, and user-friendly design to enhance the website's aesthetics and functionality.",
  },
];

const moduleAccessMap: Record<string, string> = {
  MAGP_CREATOR: "MAGP",
  MAGP_REVIEWER: "MAGP",
  ERAMAN_CREATOR: "ERAMAN",
  ERAMAN_REVIEWER: "ERAMAN",
  APSS_CREATOR: "APSS",
  APSS_REVIEWER: "APSS",
  EMPLOYEEAPP_CREATOR: "EMPLOYEEAPP",
  EMPLOYEEAPP_REVIEWER: "EMPLOYEEAPP",
  MAHB_CORPORATE_CREATOR: "CORPORATE",
  MAHB_CORPORATE_REVIEWER: "CORPORATE",
  PASSENGER_CREATOR: "PASSENGER BUTTERFLY EFFECT",
  PASSENGER_REVIEWER: "PASSENGER BUTTERFLY EFFECT",
  PASSENGER_ECMS_CREATOR: "PASSENGER ECMS",
  PASSENGER_ECMS_REVIEWER: "PASSENGER ECMS"
};

export const Dedicated = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [currentModule, setCurrentModule] = useLocalStorage("currentModule", null);

  useEffect(() => {
    console.log("currentModule useeffect", currentModule);
    if (currentModule) {
      if (currentModule === "MAGP") {
        navigate(`/dedicated/${getModulePath(currentModule)}/approval-management`, { replace: true });
      } else if (currentModule === "ERAMAN") {
        navigate("/dedicated/eraman/epc-applications");
      } else if (currentModule === "PASSENGER ECMS") {
        navigate(`/auth/dedicated/passenger/airport`, { replace: true });
        return;
      } else if (currentModule === "PASSENGER BUTTERFLY EFFECT") {
        navigate(`/dedicated/passenger/butterfly-effect`, { replace: true });
        return;
      } else if (currentModule === "CORPORATE") {
        navigate("/dedicated/corporate/approval-management?activeTab=pending");
      } else {
        navigate("/dedicated/default-module");
      }
    }
  }, [currentModule, navigate]);

  useEffect(() => {
    const tokenGen = async () => {
      try {
        const response = await axios.get(`${magpApiURL}/api/developer/apim-token`);
        localStorage.setItem("apim", JSON.stringify(response?.data));
      } catch (err) {
        console.log(err, "error in generating apim token");
      }
    };
    tokenGen();
  }, []);

  const allowedModules = user?.access?.includes("SUPER_ADMIN")
    ? dedicatedModules
    : dedicatedModules.filter((module) => user?.access?.some((access) => moduleAccessMap[access] === module.name));

  return (
    <div className="px-20 py-8 relative">
      <img
        src={Pattern}
        className="absolute top-0 right-0"
        alt="Pattern"
      />

      <img
        src={Logo}
        className="h-16"
        alt="Logo"
      />
      <h1 className="text-lg font-semibold text-pink mt-6">Select Module</h1>
      <p className="text-sm font-normal text-neutral-1 mb-5">Let&apos;s get started! Select the module to continue</p>

      <div className="grid grid-cols-2 gap-10 mt-10">
        {allowedModules.map((module) => (
          <div
            key={module.name}
            onClick={() => setCurrentModule(module.name)}
            className={`relative flex items-center gap-8 cursor-pointer rounded-2xl bg-${module.backgroundColor} p-6 shadow`}
          >
            <img
              src={module.logo}
              className="w-14 h-14"
              alt="Logo"
            />
            <div className="relative flex-1">
              <h2 className="text-lg font-semibold text-darkBlue">{module.label}</h2>
              <p className="text-sm font-normal text-darkBlue max-w-[396px]">
                {module.content || "No description available for this module."}
              </p>
              <div className="w-7 h-7 absolute right-0 bottom-0 p-1 bg-white flex items-center justify-center rounded-full">
                <img
                  src={ChevronRight}
                  className="w-4 h-4"
                  alt="Chevron Right"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
